import { render, staticRenderFns } from "./Reports.vue?vue&type=template&id=18b1aa1f&scoped=true&"
import script from "./Reports.vue?vue&type=script&lang=js&"
export * from "./Reports.vue?vue&type=script&lang=js&"
import style0 from "./Reports.scss?vue&type=style&index=0&id=18b1aa1f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b1aa1f",
  null
  
)

export default component.exports